<template>
  <div class="editor-container" :class="{backColorB: bCb}" @click="clearRightMenu"
       @click.right="clearRightMenu(1)">
    <div class="editor-header-top">
      <editor-header></editor-header>
    </div>
    <!-- :options="options" -->

    <!-- @visionPattern="visionPattern" -->
    <editorTop :taskTypeNames='taskTypeName' :queryDatas="queryData" :bCb="bCb"
               :termSubmits="termSubmit" :interpreteruids="interpreteruid" :isSplits="isSplit"
               :ifSubmits="ifSubmit" :roleLevel="roleLevel" :isSourceEds="isSourceEd"
               :isPreMts="isPreMt" @seekShow="seekShow" :sentenceShows="sentenceShow"
               @splitSentence="splitSentence" @mergeSentence="mergeSentence"
               @rigBoxShow="rigBoxShow" @sizeEnlarge="sizeEnlarge" @sizeNarrow="sizeNarrow"
               @submit="submit" @copySource="copySource" @anewTranslate="anewTranslate"
               @sourceEditor="sourceEditor" @setRecord="setRecord" @reTranslate="reTranslation"
               @interpreterTask="interpreterTask" @interpreterTaskOut="interpreterTaskOut"
               @toTaskIndex="toTaskIndex" :states="state" />
    <div class="main-box">
      <div class="content-box cat-trans" id="redactBox" ref="redactBox"
           @mouseup="pitchOn($event, 1)" @mouseover="styleOver($event)" @mouseout="styleOut($event)"
           @contextmenu="oncontextmenu($event, 1)" @input="AutoComple($event)"
           @click="onContextClick($event)">
        <div id="translation" style="position: relative;pointer-events: auto;" ref="viewBox2">
          <div ref="targetBox" v-for="(item, index) in targetList" :key="index"
               v-html="item.data" />
          <postil style="top:5px" :isAddPostil="isAddPostil" :isUpdatePostil="isUpdatePostil"
                  @setIsSeekBox="setIsSeekBox" />
        </div>
        <!-- <i class="icon-left riBoxSw" v-show="RigBoxIf" @click="startRigBox"
         ></i>
        <i class="icon-right riBoxSw" v-show="!RigBoxIf" @click="startRigBox"
         ></i> -->
      </div>
      <div class="rigContantBox" ref="rigContantBox">
        <!-- :queryDatas="queryData"  -->
        <editorOperation ref="editorOperation" :termHintList="termHintList" :queryData="queryData"
                         :memoryHintList="memoryHintList" :isSeekBox="isSeekBox" :seekTxt="seekTxt"
                         :seekTxt2="seekTxt2" :seekNum="seekNum" :seekNum2="seekNum2"
                         :inputTxt="inputTxt" :bCb="bCb" :targetInput="targetInput"
                         :postilTarget="postilTarget" :ifSubmit="isUpdatePostilBut"
                         :updatePostilTxt="updatePostilTxt" :postilId="postilId" @addTerm="addTerm"
                         @onInputTxt="onInputTxt" @onTargetInput="onTargetInput"
                         @onSeekTxt="onSeekTxt" @onSeekTxt2="onSeekTxt2" @setPostilId="setPostilId"
                         @onUpdatePostilTxt="onUpdatePostilTxt" @setIsSeekBox="setIsSeekBox"
                         @goQA="goQA" @seekChange="seekChange" @onReplace="onReplace"
                         @replaceChange="replaceChange" @previous="previous" @seekNext="seekNext">
        </editorOperation>
      </div>
    </div>
    <!-- v-show="rightMenuShow" -->
    <rightMenu ref="rightMenu" v-show="rightMenuShow" @rigBoxShow="rigBoxShow"
               @rigAddTerm="rigAddTerm" @anewTranslate="anewTranslate"
               @mergeSentence="mergeSentence" @splitSentence="splitSentence"
               @unlockSentence="unlockSentence" @copySource="copySource" :inputTxt="inputTxt"
               :typeShow="typeShow" :ifSubmit="ifSubmit" :wordEditorTier="$route.name"
               :isEditR="isEditR" :sentenceShow="sentenceShow" :isLock="isLock"
               :format="(queryData.fileSuffix)" />

    <messageBox v-if="mesBox" :isShow="mesBox" :tit="tit" :txt="txt" :imgSrc="imgSrc" :cancel="true"
                confirmBut="保存并替换" callBut="保存至术语表" @message="empty" @messageIf="messageIf"
                @onCancel="onCancel"></messageBox>
    <!-- 术语添加弹窗 -->
    <termDialog :dialogVisible="dialogVisible"></termDialog>
  </div>
</template>

<script>
import EditorTop from "../../../editorTop";
import messageBox from "@/common/messageBox.vue";
// import editorHeader from "./common/editorHeader.vue";
import editorHeader from "../../../editorTop/index.vue";
import editorTop from "./common/editorTop.vue";
import rightMenu from "./common/rightMenu.vue";
import editorMixin from './common/mixin';
// import seek from './common/seek.vue';
import debounce from 'lodash.debounce'; // 防抖函数
import editorOperation from './common/editorOperation.vue';
import postil from './common/postil.vue';
import termDialog from './common/termDialog.vue';
import { setCursorEnd } from '@/services/common.js';

let rightClickElement;
export default {
  name: "wordEditorTier",
  mixins: [editorMixin],
  components: {
    editorHeader,
    editorTop,
    messageBox,
    // rightDrawer,
    rightMenu,
    postil,
    editorOperation,
    termDialog
  },
  data() {
    return {
      targetList: [],
      scroll: "",
      rightMenuShow: false,
      txtList: [], // 复制用的
      isTerm: false,
      isSearch: false,
      inputTxt: "",
      timer: null,
      timer2: null,
      timeOut: null,
      scale_x: "1",
      scale_y: "1",
      targetInput: "",
      dictItemList: "", // 存储查词数据
      loading: "",
      userId: "",
      termHintList: [],
      memoryHintList: [],
      num: "1",
      imgSrc: require("@/assets/imgs/editor/qr_code_bg.png"), // 弹窗title背景图
      mesBox: false,
      tit: "添加术语",
      txt: "是否保存到项目术语库并替换所有未确认句段？",
      queryData: {},
      saveHint: "",
      isWordBox: false,
      words: [],
      resWord: "",
      seekTxt: "",
      seekTxt2: "",
      project: false,
      cutOff: false,
      isSeekBox: false, // 1 = 查找/替换 2 = 查词 3 = 添加术语
      completion: "",
      contextRight: "",
      seekIndex: 0,
      seekNum: 0,
      seekNum2: 0,
      loadinginstace: "",
      mendSentId: "",
      cursor: "", // 光标
      userIdList: [],
      backgroundImg: require("@/assets/imgs/editor/normal_lock.png"),
      RigBoxIf: true,
      RigSwitchVal: false,
      isSplit: 1,
      progress: 0,
      taskTypeName: "",
      bCb: false,
      splitSourceSent: "",
      splitTargetSent: "",
      myZoom: 1,
      // editorDe: "#cfe8cc", // 编辑器完成的样式
      // editorOff: "#454545", // 编辑器不可编辑的样式
      // editorNo: "#808080", // 编辑器可编辑的样式
      itermColor: "", // 术语背景颜色
      seekOut: "",
      progressTime: null,
      scrollD: "",
      ifRepeatLock: 0, // 是否重复句段锁定 1为锁定
      ifOnlyPreview: false, // 全文不可编辑为1,
      postilTxt: "",
      // sentenceShow: true
      state: true,
    };
  },
  async created() {
    await this.queryBySentId();
    this.getWord(1, 1, true);
  },
  mounted() {
    const that = this;
    this.getUserInfo();
    this.getprogress();
    // 通过$refs获取dom元素
    let dom = this.$refs.redactBox;
    dom.addEventListener("drop", function (event) {
      // 获取拖拽文本内容
      var text = event.dataTransfer.getData("text");
      if (
        this.value == "" &&
        text.match(/\d/g) &&
        text.match(/\d/g).length == 11
      ) {
        event.preventDefault();
        dom.value = text.replace(/\D/g, "");
        dom.select();
      }
    });
    // 监听这个dom的scroll事件
    this.$refs.viewBox2.addEventListener("scroll", this.viewBoxScroll, false);
    window.onresize = function () {
      that.isEditer = false;
      that.isPostil = false
    }
    // 取消事件的默认行为
    // window.addEventListener( 'keydown',
    // function(e) {
    //     if (e.keyCode == 17)  {
    //         event.preventDefault(e);
    //     }
    // });
  },
  beforeDestroy() {
    window.onresize = null;
    this.$message.closeAll();
    this.$refs.viewBox2.removeEventListener("scroll", this.viewBoxScroll);
    this.loadinginstace.close(); // loading清除
  },
  methods: {
    async getUserInfo() {
      let self = this;
      self.$store.dispatch("layout/userInfo").then(resp => {
        if (!!resp && resp.status === 200 && resp.success) {
          let result = resp.result;
          let companyCode = result.lastSelectCompany.code;
          localStorage.setItem("myUser", JSON.stringify(result));
          localStorage.setItem("userInfo", JSON.stringify(result));
          localStorage.setItem("sourceAppid", result.sourceAppid);
          localStorage.setItem("companyCode", result.lastSelectCompany.code); // 公司编码
          localStorage.setItem("myCompanyCode", result.lastSelectCompany.code); // 公司编码
          this.$store.dispatch('ws/UPDATE_LOGIN_INFO', result);
        }
      });
    },
    // 取消译员任务段落高亮
    interpreterTaskOut() {
      let taskType = this.queryData.taskType;
      this.interpreterTaskDomList.forEach(item => {
        let status = item.getAttribute("status");
        let title = item.getAttribute("title");
        if (
          ((status == 2 && taskType === 1) ||
            (status == 4 && taskType === 2) ||
            (status == 5 && taskType === 3)) &&
          title !== "其他译员任务" &&
          item.isContentEditable
        ) {
          item.style.background = this.editorDe;
        } else {
          item.style.background = "";
        }
      })
    },
    // 译员任务段落高亮
    interpreterTask(uid) {
      let doms = this.$refs.redactBox.querySelectorAll(`span[uid='${uid}']`);
      this.interpreterTaskDomList = []
      doms.forEach(item => {
        if (item.getAttribute("type") === "target") {
          this.interpreterTaskDomList.push(item)
          item.style.background = "#DBEEFF"
        }
      })
    },
    // qa用来定位dom
    domFun(row) {
      return this.$refs.viewBox2.querySelectorAll(
        `span[sid='${row.id}']`
      )[1];
    },
    // 用来编辑原文
    sourceDomFun(id) {
      return this.$refs.viewBox2.querySelectorAll(
        `span[sid='${id}']`
      )[0];
    },
    //  右侧菜单开关
    startRigBox() {
      if (!this.RigBoxIf) {
        this.RigBoxIf = true;
        this.RigSwitchVal = "true";
        this.$nextTick(() => {
          // this.$refs.redactBox.style.width = "calc(100% - 500px)";
          this.$refs.rigContantBox.style.width = "300px";
          this.$refs.rigContantBox.style.marginRight = "20px";
        });
      } else {
        this.RigBoxIf = false;
        this.RigSwitchVal = "false";
        this.$nextTick(() => {
          // this.$refs.redactBox.style.width = "calc(100% - 180px)";
          this.$refs.rigContantBox.style.width = "0px";
          this.$refs.rigContantBox.style.marginRight = "0";
        });
      }
    },
    editorThemeStyle(type) {
      const { taskType } = this.queryData
      if (type == "standard") {  // 日间
        this.bCb = false;
        sessionStorage.setItem("sessionBCb", this.bCb);
        this.editorDe = "#cfe8cc"; //确定块的
        this.editorOff = "rgb(170,170,170)";
        this.editorNo = "#454545";
        this.itermColor = "";
        this.focusBack = "#e5f1be";
        // 编辑器字体颜色  译文
        let translation = document.getElementById("translation");
        let ary = translation.getElementsByTagName("span");
        let arr = Array.from(ary);
        arr.forEach(item => {
          if (item.getAttribute("type")) {
            if (item.getAttribute("contenteditable") === this.contentEditableValue && item.getAttribute("type") === "target") {
              item.style.color = this.editorNo;
              this.setInsertSty(item);
            } else if (item.getAttribute("contenteditable") === "false") {
              item.style.color = this.editorOff
              this.setInsertSty(item, "disabled");
            }
          }
          let status = item.getAttribute("status")
          if (((status == 2 && taskType === 1) || (status == 4 && taskType === 2) || (status == 5 && taskType === 3)) && (item.getAttribute("contenteditable") === this.contentEditableValue && item.getAttribute("type") === "target")) {
            // status值为 -1删除 0未翻译 1机器翻译 2已编辑 3已完成 4审校
            item.style.background = this.editorDe;
          }
        });

      } else if (type == "dark") { // 夜间
        this.bCb = true;
        sessionStorage.setItem("sessionBCb", this.bCb)
        this.editorDe = "#50606e" //确定块的颜色
        this.editorOff = "#696A6D";
        this.editorNo = "#AAABAD";
        this.itermColor = "#2F333B";
        this.focusBack = "#405982";
        // 编辑器字体颜色  译文
        let translation = document.getElementById("translation");
        let ary = translation.getElementsByTagName("span");
        let arr = Array.from(ary);
        arr.forEach(item => {
          if (item.getAttribute("type")) {
            if (item.getAttribute("contenteditable") === this.contentEditableValue && item.getAttribute("type") === "target") {
              item.style.color = this.editorNo;
              this.setInsertSty(item);
              // this.setTermSty(item);
            } else if (item.getAttribute("contenteditable") === "false") {
              item.style.color = this.editorOff;
              this.setInsertSty(item, "disabled");
            }
          }
          let status = item.getAttribute("status")
          if (((status == 2 && taskType === 1) || (status == 4 && taskType === 2) || (status == 5 && taskType === 3)) && (item.getAttribute("contenteditable") === this.contentEditableValue && item.getAttribute("type") === "target")) {
            // status值为 -1删除 0未翻译 1机器翻译 2已编辑 3已完成 4审校
            item.style.background = this.editorDe;
          }
        });
      }
    },


    // // 夜间模式
    // visionPattern (e) {
    //   console.log(e);
    //   let taskType = this.queryData.taskType;
    //   if (e == "1") {  // 日间
    //     this.bCb = false;
    //     sessionStorage.setItem("sessionBCb", this.bCb);
    //     this.editorDe = "#cfe8cc"; //确定块的
    //     this.editorOff = "rgb(170,170,170)";
    //     this.editorNo = "#454545";
    //     this.itermColor = "";
    //     this.focusBack = "#e5f1be";

    //     // 编辑器字体颜色  译文
    //     let translation = document.getElementById("translation");
    //     let ary = translation.getElementsByTagName("span");
    //     let arr = Array.from(ary);
    //     console.log(arr)
    //     arr.forEach(item => {
    //       if (item.getAttribute("type")) {
    //         if (item.getAttribute("contenteditable") === this.contentEditableValue && item.getAttribute("type") === "target") {
    //           item.style.color = this.editorNo;
    //           this.setInsertSty(item);
    //         } else if (item.getAttribute("contenteditable") === "false") {
    //           item.style.color = this.editorOff
    //           this.setInsertSty(item, "disabled");
    //         }

    //         // this.setTermSty(item);
    //       }
    //       let status = item.getAttribute("status")
    //       if (((status == 2 && taskType === 1) || (status == 4 && taskType === 2) || (status == 5 && taskType === 3)) && (item.getAttribute("contenteditable") === this.contentEditableValue && item.getAttribute("type") === "target")) {
    //         // status值为 -1删除 0未翻译 1机器翻译 2已编辑 3已完成 4审校
    //         item.style.background = this.editorDe;
    //       }

    //     });

    //   } else if (e == "2") { // 夜间
    //     this.bCb = true;
    //     sessionStorage.setItem("sessionBCb", this.bCb)
    //     this.editorDe = "#50606e" //确定块的颜色
    //     this.editorOff = "#696A6D";
    //     this.editorNo = "#AAABAD";
    //     this.itermColor = "#2F333B";
    //     this.focusBack = "#405982";
    //     // 编辑器字体颜色  译文
    //     let translation = document.getElementById("translation");
    //     let ary = translation.getElementsByTagName("span");
    //     let arr = Array.from(ary);
    //     arr.forEach(item => {
    //       if (item.getAttribute("type")) {
    //         if (item.getAttribute("contenteditable") === this.contentEditableValue && item.getAttribute("type") === "target") {
    //           item.style.color = this.editorNo;
    //           this.setInsertSty(item);
    //           // this.setTermSty(item);
    //         } else if (item.getAttribute("contenteditable") === "false") {
    //           item.style.color = this.editorOff;
    //           this.setInsertSty(item, "disabled");
    //         }
    //       }
    //       let status = item.getAttribute("status")
    //       if (((status == 2 && taskType === 1) || (status == 4 && taskType === 2) || (status == 5 && taskType === 3)) && (item.getAttribute("contenteditable") === this.contentEditableValue && item.getAttribute("type") === "target")) {
    //         // status值为 -1删除 0未翻译 1机器翻译 2已编辑 3已完成 4审校
    //         item.style.background = this.editorDe;
    //       }
    //     });
    //   }
    // },
    // 译文滑动
    viewBoxScroll() {
      let that = this;
      this.rightMenuShow = false;
      let viewBox2 = this.$refs.viewBox2;
      let htmlHeight = viewBox2.clientHeight;
      if (viewBox2.scrollTop + htmlHeight + 10 > viewBox2.scrollHeight) {
        if (!this.timer2) {
          if (this.cutOff) {
            return;
          }
          this.num++;
          this.timer2 = window.setTimeout(function () {
            that.getWord(that.num, 1);
            that.timer2 = null;
          }, 1000);
        }
      }
      if (viewBox2.scrollTop < 50 && this.num > 20) {
        this.cutOff = false;
        let page = "";
        if (!this.timeOut) {
          this.timeOut = window.setTimeout(function () {
            page = that.num - 20;
            that.num--;
            that.getWord(page, 2);
            that.timeOut = null;
          }, 500);
        }
      }
    },
    // 重新机翻句段
    async anewTranslate() {
      let sid = rightClickElement.getAttribute("sid");
      if (!sid) {
        return
      }
      let rigTag = this.$refs.viewBox2.querySelectorAll(
        `span[sid='${sid}']`
      )[1];
      if (!rightClickElement.isContentEditable) {
        this.$message.closeAll();
        this.$message({
          message: "不可编辑句段不支持重新机翻",
          type: "warning"
        });
        return
      }
      const res = await this.catReq1Service(
        "/api/v1/file/get_sent_machine_translation",
        {
          sid,
          companyCode: localStorage.myCompanyCode,
          taskType: this.queryData.taskType,
          fileId: this.queryData.fileId,
          taskId: this.queryData.taskId
        },
        "get"
      );
      if (!res.success) {
        return;
      }
      this.sentenceShow = false;
      rigTag.innerText = res.result.convertStr;
      this.disposeUpdate(rigTag);
    },
    // 缩小
    sizeNarrow() {
      if (this.myZoom < 0.9) {
        return
      }
      this.myZoom = this.myZoom - 0.2;
      this.$nextTick(() => {
        this.$refs.viewBox2.style.zoom = this.myZoom;
      })
    },
    // 放大
    sizeEnlarge() {
      if (this.myZoom > 1.1) {
        return
      }
      this.myZoom = this.myZoom + 0.2;
      this.$nextTick(() => {
        this.$refs.viewBox2.style.zoom = this.myZoom;
      })
    },
    // 拆分句段
    async splitSentence(e) {
      let that = this;
      if (rightClickElement.getAttribute("editable") !== "true") { // 要拆分的句段不能为不可编辑
        this.$message.closeAll();
        this.$message({
          message: "不可编辑句段不支持拆分",
          type: "warning"
        });
        return
      }

      let sentId = rightClickElement.getAttribute("sid");
      let params = {
        isNewVersion: 1,
        sentId,
        transFileId: this.queryData.fileId,
        transFileSentList: [{ sourceSent: this.splitSourceSent }, { sourceSent: this.splitTargetSent }]
      };
      const res = await this.catReq1Service(
        "/api/v1/sent/splitTransSent",
        params,
        "post"
      );
      if (!res.success) {
        return;
      }
      that.sentenceShow = false;
      let SourceSentData = res.result[0];
      let TargetSentData = res.result[1];
      // 原文部分
      let parentDom = rightClickElement.parentNode;
      let strNode = document.createElement("span"); // 创建一个节点用来放拆分的上一部分
      let strTextNode = document.createTextNode(SourceSentData.sourceSent);
      strNode.appendChild(strTextNode);
      parentDom.insertBefore(strNode, rightClickElement)
      let sourceAttrs = rightClickElement.attributes;
      for (let i = sourceAttrs.length - 1; i >= 0; i--) { // 复制属性
        strNode.setAttribute(sourceAttrs[i].name, sourceAttrs[i].value);
      }
      strNode.setAttribute("sourceMd516", SourceSentData.sourceMd516);
      rightClickElement.setAttribute("sourceMd516", TargetSentData.sourceMd516);
      rightClickElement.setAttribute("sid", TargetSentData.id);
      rightClickElement.innerText = TargetSentData.sourceSent;
      strNode.addEventListener("click", function ($event) {
        that.getCursortPosition($event);
      });
      strNode.addEventListener("input", function ($event) {
        $event.target.innerText = that.myInnerText;
      });
      strNode.addEventListener("focus", function ($event) {
        that.myInnerText = $event.target.innerText;
        that.getCursortPosition($event);
      });
      // 译文部分
      let targetTag = that.$refs.viewBox2.querySelectorAll(`span[sid='${sentId}']`)[1]; // 创建一个节点用来放拆分的下一部分
      let targetParentDom = targetTag.parentNode;
      let targetStrNode = document.createElement("span"); // 创建一个节点用来放拆分的上一部分
      let targetStrTextNode = document.createTextNode(SourceSentData.targetSent);
      targetStrNode.onkeydown = function ($event) {
        that.enterKey($event);
      };
      // targetStrNode.oninput = function ($event) {

      // };
      targetStrNode.onblur = function ($event) {
        that.blurText($event, that.canIdList);
      };
      targetStrNode.onfocus = function ($event) {
        that.onFocus($event.target);
      };
      targetStrNode.appendChild(targetStrTextNode);
      targetParentDom.insertBefore(targetStrNode, targetTag)
      let attrs = targetTag.attributes;
      for (let i = attrs.length - 1; i >= 0; i--) { // 复制属性
        targetStrNode.setAttribute(attrs[i].name, attrs[i].value);
      }
      targetStrNode.setAttribute("sourceMd516", SourceSentData.sourceMd516);
      targetTag.setAttribute("sourceMd516", TargetSentData.sourceMd516);
      targetTag.setAttribute("sid", TargetSentData.id);
      targetStrNode.setAttribute("status", SourceSentData.status);
      targetTag.innerText = TargetSentData.targetSent;
      this.$message.closeAll();
      this.$message({
        message: "拆分成功!",
        type: "success"
      });
    },
    // 合并句段
    async mergeSentence() {
      let that = this;
      let dom = rightClickElement.nextElementSibling;
      if (!rightClickElement.isContentEditable) { // 要合并的句段不能为不可编辑
        this.$message.closeAll();
        this.$message({
          message: "该句段不支持合并",
          type: "warning"
        });
        return
      }
      let sourceSentId = rightClickElement.getAttribute("sid");
      let source = this.$refs.viewBox2.querySelectorAll(`span[type='source']`);
      let targetDom;
      source.forEach((item, index) => {
        if (item === rightClickElement) {
          function dom2(params) {
            if (!source[params + 1]) {
              return
            }
            if (source[params + 1].innerText === "") {
              dom2(params + 1);
              return
            }
            targetDom = source[params + 1]
          }

          dom2(index)
        }
      });
      if (!targetDom) {
        return
      }
      let targetSentId = targetDom.getAttribute("sid");
      const res = await this.catReq1Service(
        "/api/v1/sent/mergeTransSent",
        { targetSentId, sourceSentId, transFileId: that.queryData.fileId },
        "post"
      );
      if (!res.success) {
        return;
      }
      that.sentenceShow = false;
      // rightClickElement.innerText =
      //   rightClickElement.innerText + targetDom.innerText;
      rightClickElement.innerText = res.result.sourceSent;
      targetDom.innerText = "";
      targetDom.setAttribute("contenteditable", "false");
      const sourceTag = this.$refs.viewBox2.querySelectorAll(`span[sid='${sourceSentId}']`)[1];
      const targetTag = this.$refs.viewBox2.querySelectorAll(`span[sid='${targetSentId}']`)[1];
      // sourceTag.innerText = sourceTag.innerText + targetTag.innerText;
      sourceTag.innerText = res.result.targetSent;
      targetTag.innerText = "";
      this.$message.closeAll();
      this.$message({
        message: "合并成功!",
        type: "success"
      });
    },
    unlockSentence() {
      let sentId = rightClickElement.getAttribute("sid");
      let sourceTag = this.$refs.viewBox2.querySelector(`span[sid='${sentId}']`);
      this.unlockSentenceBase(sourceTag, rightClickElement, 2)
    },
    // 获取光标位置
    getCursortPosition(e) {
      var eleP = e.target.parentNode; //获取父级元素
      var pos = 0;
      // debugger
      pos = this.getDivPosition(e.target);
      if (e.target.innerText) {
        this.splitSourceSent = e.target.innerText.slice(0, pos);
        this.splitTargetSent = e.target.innerText.slice(pos);
      }
    },
    //可编辑div获取坐标
    getDivPosition(element) {

      if (!element.getAttribute("type")) {  // 保证定位是在被编辑的元素
        element = this.getNode(element.parentNode)
      }
      this.seekNode = element;
      var caretOffset = 0;
      var doc = element.ownerDocument || element.document;
      var win = doc.defaultView || doc.parentWindow;
      var sel;
      if (typeof win.getSelection != "undefined") {
        //谷歌、火狐
        sel = win.getSelection();
        if (sel.rangeCount > 0) {
          //选中的区域
          var range = win.getSelection().getRangeAt(0);
          var preCaretRange = range.cloneRange(); //克隆一个选中区域
          preCaretRange.selectNodeContents(element); //设置选中区域的节点内容为当前节点
          preCaretRange.setEnd(range.endContainer, range.endOffset); //重置选中区域的结束位置
          caretOffset = preCaretRange.toString().length;
        }
      } else if ((sel = doc.selection) && sel.type != "Control") {
        //IE
        var textRange = sel.createRange();
        var preCaretTextRange = doc.body.createTextRange();
        console.log(textRange, sel, preCaretTextRange);

        preCaretTextRange.moveToElementText(element);
        preCaretTextRange.setEndPoint("EndToEnd", textRange);
        caretOffset = preCaretTextRange.text.length;
      }
      let anchorSid = this.getNode(sel.anchorNode.parentNode).getAttribute("sid");
      let extentSid = this.getNode(sel.extentNode.parentNode).getAttribute("sid");
      // debugger
      if (anchorSid === extentSid && element.getAttribute("contenteditable") != "false") {
        this.postilContrast = true
      } else {
        this.postilContrast = false
      }
      return caretOffset;
    },
    activeFor(obj) {
      let domList = obj.tag.getElementsByClassName("span-active");
      if (!domList) {
        return
      }
      for (let j = obj.start; j < obj.end; j++) {
        domList[j].scrollIntoView();
        domList[j].classList.add('current-box')
      }
    },
    // 开启编辑器
    codeRigBox() {
      this.RigBoxIf = true;
      this.RigSwitchVal = "true";
      this.$nextTick(() => {
        // this.$refs.redactBox.style.width = "calc(100% - 360px)";
        this.$refs.rigContantBox.style.width = "300px";
        this.$refs.rigContantBox.style.marginRight = "20px";
      });
    },
    seekShow() {
      if (this.isSeekBox === 1) {
        this.isSeekBox = false;
        this.seekTxt = "";
        this.seekTxt2 = "";
        this.actList = [];
      } else {
        this.isSeekBox = 1
      }
    },
    // 查找 下一个
    seekNext() {

      let domList = document.getElementsByClassName("seekActive");
      //  if (this.seekIndex===0) {
      //    domList[i].style.background = "#555";
      //  }
      if (this.actList.length === 0 || this.actList.length === 1) {
        return;
      }
      let currentBoxList = document.getElementsByClassName('current-box');
      currentBoxList = Array.from(currentBoxList);
      currentBoxList.forEach(item => {
        item.classList.remove('current-box')
      });
      if (this.seekIndex >= this.actList.length - 1) {
        this.activeFor(this.actList[0]);
        // this.actList[0].style.background = "rgb(163, 217, 241)";
        // this.actList[this.seekIndex].style.background = "yellow";
        this.seekIndex = 0;
        // this.actList[this.seekIndex].tag.scrollIntoView();
        this.seekNum = 1;
        return;
      }
      this.seekIndex++;
      this.seekNum++;
      this.activeFor(this.actList[this.seekIndex])

      // this.actList[this.seekIndex].tag.scrollIntoView();
      // debugger
      // if (this.seekIndex > 0) {

      //   this.actList[this.seekIndex].style.background = "rgb(163, 217, 241)";
      //   this.actList[this.seekIndex - 1].style.background = "yellow";
      // } else {
      //   this.actList[this.seekIndex].style.background = "rgb(163, 217, 241)";
      // }
    },
    // 查找 上一个
    previous() {
      let domList = document.getElementsByClassName("seekActive");
      let len = this.actList.length;

      if (this.actList.length === 0 || this.actList.length === 1) {
        return;
      }
      let currentBoxList = document.getElementsByClassName('current-box');
      currentBoxList = Array.from(currentBoxList);
      currentBoxList.forEach(item => {
        item.classList.remove('current-box')
      });
      if (this.seekIndex === 0) {
        // this.actList[len - 1].style.background = "rgb(163, 217, 241)";
        // this.actList[0].style.background = "yellow";
        this.activeFor(this.actList[len - 1]);
        this.seekIndex = len - 1;
        // this.actList[this.seekIndex].scrollIntoView();
        this.seekNum = len;
        return;
      }
      this.seekIndex--;
      // if (this.seekNum<len) {
      this.seekNum--;
      // this.actList[this.seekIndex].scrollIntoView();
      // }
      this.activeFor(this.actList[this.seekIndex])
      // this.actList[this.seekIndex].style.background = "rgb(163, 217, 241)";
      // this.actList[this.seekIndex + 1].style.background = "yellow";
    },
    // 查找
    seekChange() {
      let that = this;
      this.delClassList();
      this.seekNum2 = 0;
      this.seekNum = 0;
      this.seekIndex = 0;
      if (this.seekTxt === "") {
        return;
      }
      let oAt = this.$refs.redactBox;
      let dom = oAt.querySelectorAll(`span[sid]`);
      dom = Array.from(dom);
      let seekTxt = this.seekTxt;
      if (seekTxt.indexOf(".") != -1 || seekTxt.indexOf("?") != -1) {
        let ary = seekTxt.split("");
        for (let i = 0; i < ary.length; i++) {
          if (ary[i] === "." || ary[i] === "?" || ary[i] === "(" || ary[i] === ")") {
            ary[i] = "\\" + ary[i]
          }
        }
        seekTxt = ary.join("")
      }
      let reg = new RegExp(seekTxt, "ig");
      let nodeList = [];

      function getOf(item, text, ary, len) {
        let index = item.innerText.indexOf(text, len);
        if (index != -1) {
          ary.push({
            start: index,
            end: index + text.length,
            tag: item
          });
          index = index + text.length;
          return getOf(item, text, ary, index)
        } else {
          return ary
        }
      }

      for (let i = 0; i < dom.length; i++) {
        const item = dom[i];
        let index = item.innerText.indexOf(this.seekTxt);
        if (index != -1) {
          nodeList.push({
            tag: item,
            indexList: getOf(item, this.seekTxt, [], 0)
          })
        }

      }

      function getNodeObj(tag) {
        let tagObjList = [], num = 0;
        let reg = /.{1}/g;
        if (tag.children.length < 1) {
          let nodeHtml = tag.innerText.replace(reg, function (params) {
            return (
              '<span class="span-active">' +
              params +
              "</span>"
            );
          });
          tag.innerHTML = nodeHtml;
          return
        }
        let childNodes = Array.from(tag.childNodes);
        for (let index = childNodes.length - 1; index >= 0; index--) {
          const element = childNodes[index];
          // debugger
          let len = element.innerText.length + num;
          if (element.classList.contains("span-active") && element.innerText == '') {
            tag.removeChild(element);
            return
          }
          // console.log(element.classList.contains("span-active"));
          if (!element.classList.contains("span-active")) {
            let activeStr = element.innerText.replace(reg, function (params) {
              return (
                '<span class="span-active">' +
                params +
                "</span>"
              );
            });
            element.innerHTML = activeStr;
          }
          // if (element.getAttribute("comment")) {
          //   element.setAttribute("cid", that.setCanvasSort(element)); // 设置批注
          // }
          tagObjList.push({
            start: num,
            end: len,
            tag: element,
            tagIndex: index
          });
          num = len;
        }

        return tagObjList
      }

      this.actList = [];
      nodeList.forEach(item => {
        getNodeObj(item.tag);
        this.actList.push(...item.indexList);
        let domList = item.tag.getElementsByClassName("span-active");
        console.log(domList, "domList");
        // domList = Array.from(domList);
        item.indexList.forEach(i => {
          console.log(i, "doiii");
          for (let j = i.start; j < i.end; j++) {
            console.log(domList[j], "domList[j]");
            domList[j].classList.add("seekActive");
            // domList[j].style.background = "yellow"
          }
        })
        // let activeList = item.tag.getElementsByClassName("span-active");
      })
      this.$nextTick(() => {
        this.seekNum2 = this.actList.length;
        if (this.seekNum2 === 0) {
          return
        }
        this.seekNum = 1;
        this.activeFor(this.actList[0])
        // this.actList.forEach((item,index)=>{
        //   if (item.tag === this.seekNode) {
        //     this.activeFor(item)
        //     this.seekNum = index;
        //   }
        // })
      });
      // dom.getAttribute("sentid")
      let str1 = this.$refs.viewBox2.innerHTML;
      if (!seekTxt) {
        return;
      }
    },
    activeFor(obj) {
      console.log(obj, "///");

      let domList = obj.tag.getElementsByClassName("span-active");
      domList = Array.from(domList);
      if (!domList) {
        return
      }
      for (let j = obj.start; j < obj.end; j++) {
        domList[j].classList.add('current-box')
      }
      domList[obj.start].scrollIntoView();
    },
    // 替换
    onReplace() {
      const { type } = this.queryData
      const fileTaskInfo = this.$store.getters['editor/getFileTaskInfo'];
      console.log(fileTaskInfo, 'fileTaskInfo-----------')
      if (type === 'task' && !this.ifSubmit) {
        // 提交任务不可以替换
        this.$message.closeAll();
        this.$message({
          message: "不可修改",
          type: "warning"
        });
        return;
      }
      if (this.actList.length < 1) {
        // 为空时不执行
        return;
      }
      if (this.seekIndex < 0) {
        this.seekIndex = 0
      }

      let dom = this.actList[this.seekIndex].tag;
      // this.getComments(dom)
      if (dom.isContentEditable && dom.getAttribute("type") === 'source') {
        // 只可编辑替换
        return;
      }
      let sonDom = this.actList[this.seekIndex];
      let currentBoxList = document.getElementsByClassName('current-box');
      currentBoxList = Array.from(currentBoxList);
      for (let i = currentBoxList.length - 1; i >= 0; i--) {
        if (i === 0) {
          currentBoxList[0].innerText = this.seekTxt2;
          currentBoxList[0].classList.remove('seekActive');
          currentBoxList[0].classList.remove('current-box')
        } else {
          // currentBoxList[i].parentNode.removeChild(currentBoxList[i])
          currentBoxList[i].innerText = "";
          currentBoxList[i].classList.remove('seekActive');
          currentBoxList[i].classList.remove('current-box')
        }
      }
      this.actList.splice(this.seekIndex, 1)
      // sonDom.style.background = "";
      // sonDom.innerText = this.seekTxt2;
      // sonDom.classList.remove("seekActive");
      this.disposeUpdate(dom, [], true);
      this.seekNum2 = this.actList.length;
      if (this.seekNum2 === 0) {
        this.seekNum = 0;
        return
      }
      this.seekIndex--;
      if (this.seekNum > 1) {
        this.seekNum--
      }
      if (this.seekNum2 === 1) {
        this.activeFor(this.actList[0]);
        return
      }
      this.seekNext()
    },
    // 全部替换
    async replaceChange() {
      let that = this;
      if (!this.ifSubmit) {
        // 提交任务不可以替换
        this.$message.closeAll();
        this.$message({
          message: "不可修改",
          type: "warning"
        });
        return;
      }
      console.log(this.actList, "???");
      for (let j = this.actList.length - 1; j >= 0; j--) {
        let item = this.actList[j];
        let tag = item.tag;
        // this.getComments(tag);
        if ((tag.getAttribute("contenteditable") === "0" || tag.getAttribute("contenteditable") === that.contentEditableValue) && tag.getAttribute("type") === 'target') {
          let domList = tag.getElementsByClassName('span-active');
          if (domList.length > 1) {
            for (let i = item.end - 1; i >= item.start; i--) {
              if (i === item.start) {
                domList[item.start].innerText = this.seekTxt2;
                domList[item.start].classList.remove('seekActive');
                domList[item.start].classList.remove('current-box')
              } else {
                domList[i].parentNode.removeChild(domList[i])
              }
              if (tag.innerText === '') {
                tag.innerHTML = '&ensp;'
              }
            }
          }
          this.actList.splice(j, 1);
          await this.changeTextOut(tag, [], true)
        }
      }


      // let delList = this.actList
      return
      let dom = oAt.querySelectorAll(`span[sid]`);
      let seekTxt = this.seekTxt;
      if (seekTxt.indexOf(".") != -1 || seekTxt.indexOf("?") != -1) {
        let ary = seekTxt.split("");
        for (let i = 0; i < ary.length; i++) {
          if (ary[i] === "." || ary[i] === "?") {
            ary[i] = "\\" + ary[i]
          }
        }
        seekTxt = ary.join("")
      }
      let reg = new RegExp(this.seekTxt, "ig");
      dom.forEach(item => {
        let text = item.innerHTML;
        if (item.getAttribute("contenteditable") === this.contentEditableValue) {
          let result = reg.exec(item.innerText);
          if (result) {
            if (str3 === "" && item.innerText === "") {
              // 阻止修改为空
              return;
            }
            let activeStr = item.innerText.replace(reg, function (params) {
              return (
                '<span class="seekActive" style="background:yellow;">' +
                str3 +
                "</span>"
              );
            });
            this.seekIndex = 0;
            item.innerHTML = activeStr;
            if (item.innerText === "") {
              item.innerHTML = text;
              this.$message.closeAll();
              this.$message({
                message: "对应的译文不能为空",
                type: "warning"
              });
            }
          }
        }
      });
      let translation = document.getElementById("translation");
      let seekDom = translation.getElementsByClassName("seekActive");
      seekDom = Array.from(seekDom);
      // this.seekChange();
      this.$nextTick(() => {
        for (let i = 0; i < seekDom.length; i++) {
          if (seekDom[i].parentNode) {
            if (
              seekDom[i].parentNode.getAttribute("contenteditable") ===
              this.contentEditableValue
            ) {
              this.disposeUpdate(seekDom[i].parentNode);
            }
          }

        }
        // this.seekNum2 = 0;
        // this.seekNum = 0;
      });
    },
    // 提交任务
    async submit() {
      let that = this;
      this.loadinginstace = this.$loading({ fullscreen: true });
      const res = await this.catReq1Service("/api/v1/fileTask/finishTask", {
        id: that.queryData.fileId,
        taskType: that.queryData.taskType,
        taskId: this.queryData.taskId
      });
      if (!res.success) {
        this.loadinginstace.close(); // loading清除
        return;
      } else {
        this.ifOnlyPreview = false;
        this.$message.closeAll();
        this.$message({
          message: "提交任务成功",
          type: "success"
        });
        that.isSeekBox == 5 || that.isSeekBox == 4 ? that.isSeekBox = '' : '';
        that.isAddPostil = false;
        that.isUpdatePostil = false;
        that.getprogress();
        let translation = document.getElementById("translation");
        let translationAry = translation.getElementsByTagName("span");

        that.$nextTick(() => {
          translationAry = Array.from(translationAry);
          translationAry.forEach(item => {
            if (item.getAttribute("contenteditable")) {
              item.setAttribute("contenteditable", "false");
              item.style.color = that.editorOff;
              item.style.background = "";
              item.style.backgroundColor = "";
            }
          });
          that.loadinginstace.close(); // loading清除
        });
        that.checkTaskStatus();
      }
    },
    reTranslation() {
      let that = this;
      that.ifOnlyPreview = false;
      that.isAddPostil = false;
      that.isUpdatePostil = false;
      let translation = document.getElementById("translation");
      let translationAry = translation.getElementsByTagName("span");
      that.$nextTick(() => {
        translationAry = Array.from(translationAry);
        translationAry.forEach(item => {
          if (item.getAttribute("contenteditable")) {
            item.setAttribute("contenteditable", "false");
            item.style.color = that.editorOff;
            item.style.background = "";
            item.style.backgroundColor = "";
          }
        });
        that.loadinginstace.close(); // loading清除
      });
    },
    editerChange(e) {

    },
    // isFunBut (e, isShow = 1) {
    //   this.isEditR = false;
    //   rightClickElement = e;
    //   if (e.target.getAttribute("type") === "source") {
    //     this.typeShow = true
    //     isShow = false
    //     this.sid = e.target.getAttribute("sid")
    //   } else {
    //     if (e.target.isContentEditable) {
    //       this.isEditR = true;
    //     }
    //     this.typeShow = false
    //   }
    //   isShow ? this.sentenceShow = false : this.sentenceShow = true;
    //   if (!e.target.isContentEditable) {
    //     this.sentenceShow = false
    //   }
    //   if ((e.target.getAttribute("rf") > 0 || e.target.getAttribute("rp") > 0) && this.ifRepeatLock) {
    //     this.sentenceShow = false
    //   }
    // },

    getHint(e, isShow) {
      let node = this.getNode(e.target);
      rightClickElement = node;
      if (this.rightMenuShow) {
        this.rightMenuShow = false;
      }
      e = e || window.event || arguments[0];
      if (e.stopPropagation) { //W3C阻止冒泡方法
        e.stopPropagation();
      } else {
        e.cancelBubble = true; //IE阻止冒泡方法
      }
      let acticeClass = node.getAttribute("sid");
      let lefTag = this.$refs.viewBox2.querySelectorAll(
        `span[sid='${acticeClass}']`
      )[0];
      // 实时对照
      if (this.contrastStatus) {
        this.contrastTag.innerHTML = this.contrastTag.innerText
      }
      if (e.target.isContentEditable) {
        let range = window.getSelection().getRangeAt(0);
        if (this.startOffset != range.startOffset) {
          this.contrastDebounce(lefTag, e.target)
        }
      }

      // this.editerNode = node;
      // if (!acticeClass || node.getAttribute("contenteditable") === "false") {
      //   return;
      // }
      // let status = node.getAttribute("status");
      // node.style.boxShadow = "0px 0px 5px 0px rgba(152,136,120,0.4)";
      // node.style.padding = "6px";
      // node.style.margin = "2px 0px";
      // node.style.border = "1px solid rgba(234,177,39,1)";
      // node.style.borderRadius = "3px";
    },
    onContextClick(e) {
      let node = this.getNode(e.target);
      let acticeClass = node.getAttribute("sid");
      rightClickElement = node;
      if (!acticeClass) {
        return
      }
      let domList = this.$refs.viewBox2.querySelectorAll(
        `span[sid='${acticeClass}']`
      );
      this.getmemory(domList[0].innerText);
      this.getTerm(domList[0].innerText);
      this.isFunBut(e);
      if (node.getAttribute("type") === "target") {
        this.onClick(e);
        // this.inputTxt = "";
      }
    },
    // 自定义右键菜单
    oncontextmenu(e, isShow) {
      let node = this.getNode(e.target);
      this.isFunBut(e, isShow);
      rightClickElement = node;
      e = e || window.event;
      e.preventDefault();
      e.returnValue = false;
      this.rightMenuShow = true;
      let rm = this.$refs.rightMenu.$el;
      //2.设置菜单的位置等于鼠标的坐标
      //判断：如果鼠标的位置+菜单的宽度>网页的宽度，那么就改为右边定位
      //鼠标坐标
      let mx = e.clientX;
      let my = e.clientY;
      //菜单宽度
      this.$nextTick(() => {
        let rmWidth = parseInt(rm.clientWidth);
        let rmHeight = parseInt(rm.clientHeight);
        //网页的宽度(高度用同样的方法解决)
        let pageWidth = document.documentElement.clientWidth;
        let pageHeight = document.documentElement.clientHeight;
        if (mx + rmWidth + 10 < pageWidth) {
          rm.style.left = mx + 10 + "px";
        } else {
          rm.style.left = mx - rmWidth - 10 + "px";
        }
        if (my + rmHeight + 10 < pageHeight) {
          rm.style.top = my + 10 + "px";
        } else {
          rm.style.top = my - rmHeight - 10 + "px";
        }
        //3.显示右键菜单
        setTimeout(() => {
          this.rightMenuShow = true;
        }, 10);
        //阻止默认的右键菜单显示
        return false;
      })
    },
    // 选中
    pitchOn(e, type) {
      var event = window.event || e;
      let isTarget;
      var target = event.srcElement ? event.srcElement : event.target;
      let pathList = event.composedPath();
      for (let i = 0; i < pathList.length; i++) {
        if (i > 3) {
          break
        }
        const element = pathList[i];
        if (element.getAttribute("type") === "target") {
          isTarget = true;
          break
        }
      }
      // debugger
      // if (target.getAttribute("type") === "target") {
      //   isTarget = true
      // }
      if (
        /input|textarea/i.test(target.tagName) &&
        /firefox/i.test(navigator.userAgent)
      ) {
        //Firefox在文本框内选择文字
        var staIndex = target.selectionStart;
        var endIndex = target.selectionEnd;
        if (staIndex != endIndex) {
          var sText = target.value.substring(staIndex, endIndex);
          this.tanchu(sText, target, event, type, isTarget);
        }
      } else {
        //获取选中文字
        var sText =
          document.selection == undefined
            ? document.getSelection().toString()
            : document.selection.createRange().text;
        if (sText != "") {
          //将参数传入回调函数fn
          this.tanchu(sText, target, event, type, isTarget);
        }
      }
    },
    // 选中文字
    tanchu(txt, tar, event, type, isTarget) {
      if (isTarget) {
        this.targetInput = txt;
      } else {
        this.inputTxt = txt;
        this.inputTxtLen = txt.length;
      }

      // this.inputTxt = this.inputTxt.replace(/(\s*$)/g, "");
      this.seekTxt = txt;
      this.sid = event.target.getAttribute("sid");
      this.positionInnertxt = event.target.innerText;
      this.positionEvent = event;
      let commentType = this.getNode(event.target).getAttribute("type");
      this.commentType = commentType === 'source' ? 1 : 2;
      this.caretOffset = this.getDivPosition(event.target);
      if (!this.sid) {
        this.sid = this.getNode(event.target).getAttribute("sid");
        this.positionInnertxt = this.getNode(event.target).innerText;
      }
      // this.oncontextmenu(event, type);

      if (this.isSeekBox === 1) {
        this.seekChange();
      }
      this.txtList.push(txt);
      if (this.txtList.length > 4) {
        this.txtList.shift();
      }
    },
    async getWord(data, type, isTop) {
      // type=1 滚动条向下 type=2 滚动条向上 一页展示10个页码
      let that = this;
      let marker;
      const { taskType, transStatus, fileId, taskId, userId } = this.queryData
      if (transStatus === 2) {
        // 区分进入口 项目&任务
        marker = 2; // 项目
      } else {
        marker = 1;
      }
      if (this.isScroll) { // isScroll自動加載後300毫秒不可以觸發滾動
        return
      }
      // const params = {
      //   fileId: this.queryData.fileId,
      //   partIndex: data,
      //   marker,
      //   taskType: taskType,
      //   comparedHighlight: 0,
      //   showComment: true,
      //   showTerm: true,
      // }
      const res = await this.catReq1Service(
        `/api/v1/file/load_edit_combine_file`,
        {
          fileId,
          partIndex: data,
          marker,
          taskType,
          taskId,
          comparedHighlight: this.isRecord ? 1 : 0,
          showTerm: false,
        }, "get");
      if (!res.success) {
        return
      }
      const { ifOnlyPreview, convertStr, ifRepeatLock, startSectionIndex, endSectionIndex } = res.result
      let num = 5;
      // let ifOnlyPreview = res.result.ifOnlyPreview;
      // let convertStr = res.result.convertStr;
      if (marker === 2) {   // 项目下不可编辑则不能添加术语
        this.ifOnlyPreview = !ifOnlyPreview;
      } else {  // 任务下不可编辑则不能添加术语，可编辑：在翻译状态下可以添加，审校等不可
        this.ifOnlyPreview = ifOnlyPreview ? !ifOnlyPreview : (this.queryData.taskType < 2 ? !ifOnlyPreview : false);
      }
      this.ifRepeatLock = ifRepeatLock;
      if (type === 1 && convertStr) {
        that.endIndex = data;
        this.targetList.push({
          data: convertStr,
          startSectionIndex,
          endSectionIndex
        });
        if (this.targetList.length > 20) {
          this.targetList.shift();
        }
      } else if (type === 2 && convertStr) {
        this.targetList.unshift({
          data: convertStr,
          startSectionIndex,
          endSectionIndex
        });
        if (this.targetList.length > 20) {
          that.endIndex = that.endIndex--;
          this.targetList.pop();
        }
      }
      this.$nextTick(async () => {
        if (marker === 1 && convertStr) {
          // 自动加载到自己的任务
          let uidStr;
          switch (taskType) {
            case 2:
              uidStr = `reviserid="${userId}"`;
              break;
            case 3:
              uidStr = `secondreviserid="${userId}"`;
              break;
            default:
              uidStr = `uid="${userId}"`;
              break;
          }
          if (convertStr.indexOf(uidStr) === -1 && isTop) {
            this.num++;
            this.getWord(this.num, 1, true);
            return
          } else if (isTop) {
            setTimeout(async () => {
              let dom = this.$refs.viewBox2.querySelector(`span[${uidStr}]`);
              await dom.scrollIntoView();// 自动加载的要跳转
              this.loadinginstace.close(); // loading清除
              this.isScroll = true;
              setTimeout(() => {
                this.isScroll = false;
              }, 2000);
            }, 500);
          }
        }
        await this.editorList(); // 循环编辑器增加事件及操作
        this.loadinginstace.close(); // loading清除
        if (convertStr === "") {
          this.cutOff = true;
        }
        // 避免加载一段未出现滚动条
        if (this.hasScrollbar(this.$refs.viewBox2)) {
          num = this.$refs.viewBox2.scrollTop;
          if (this.scrollD > this.$refs.viewBox2.scrollTop) {
            num = this.$refs.viewBox2.scrollTop
          }
          this.scrollD = this.$refs.viewBox2.scrollTop
        }
        // this.$refs.viewBox2.scrollTop = num;
        if (!this.hasScrollbar(this.$refs.viewBox2) && convertStr) {
          this.num++;
          this.getWord(this.num, 1, true);
        }
      });
    },
    //
    editorList() {
      let that = this,
        marker;
      let taskType = this.queryData.taskType;
      if (this.queryData.transStatus === 2) {
        // 区分进入口 项目&任务
        marker = 2; // 项目
      } else {
        marker = 1;
      }
      let targetAry = translation.getElementsByTagName("span");
      targetAry = Array.from(targetAry); /* .filter((item) => item.getAttribute("type")); */
      if (!localStorage.myFontSize) {
        localStorage.setItem("myFontSize", 1);
      }
      targetAry.forEach((item, index) => {
        if (item.getAttribute("type") === "target") {
          that.setPostilId(item);
          item.style.display = "inline-block";
          item.parentNode.style.marginTop = "5px";
          item.style.fontFamily = "微软雅黑";
          item.style.fontSize ?
            item.style.zoom = localStorage.myFontSize :
            "";
          item.style.cursor = "pointer";
          item.style.outline = "none";
          item.style.whiteSpace = "normal";
          item.style.overflowWrap = "break-word";
          item.style.width = "100%";
          // item.setAttribute("class",'target')
          // that.css1(`.target:befter{content:\'url("~@/assets/imgs/editor/bianji.png")\';}`)
          if (
            item.getAttribute("uid") &&
            item.getAttribute("uid") !== this.queryData.userId + "" &&
            marker === 1 && taskType === 1
          ) {
            item.setAttribute("title", "其他译员任务");
          } else if (item.getAttribute("reviserid") &&
            item.getAttribute("reviserid") !== this.queryData.userId + "" &&
            marker === 1 && taskType === 2) {
            item.setAttribute("title", "其他审校任务");
          } else if (item.getAttribute("secondreviserid") &&
            item.getAttribute("secondreviserid") !== this.queryData.userId + "" &&
            marker === 1 && taskType === 3) {
            item.setAttribute("title", "其他复审任务");
          }
          if (item.getAttribute("uk") !== "1" && item.getAttribute("rf") > 0 && this.ifRepeatLock) {
            // 锁定重复句段
            item.setAttribute("contenteditable", "false");
            item.setAttribute("title", "文件内重复句段锁定");
          } else if (item.getAttribute("uk") !== "1" && item.getAttribute("rp") > 0 && this.ifRepeatLock) {
            item.setAttribute("contenteditable", "false");
            item.setAttribute("title", "项目内跨文件重复句段锁定");
          }
          if (item.innerText === '') {
            item.setAttribute("contenteditable", "false");
          }
          if (item.getAttribute('contenteditable') === 'plaintext-only') {
            item.setAttribute('contenteditable', that.contentEditableValue)
          }
          if (item.isContentEditable && item.getAttribute("type") === "target") {
            // that.setTermSty(item) // 设置术语样式
            that.setInsertSty(item); // 设置新增文本样式
            let status = item.getAttribute("status");
            if ((status == 2 && taskType === 1) || (status == 4 && taskType === 2) || (status == 5 && taskType === 3)) {
              // status值为 -1删除 0未翻译 1机器翻译 2已编辑 3已完成 4审校 5复审
              item.style.background = this.editorDe;
            }
            item.onkeydown = function ($event) {
              that.enterKey($event);
            };
            item.oninput = function ($event) {

            };
            item.onblur = function ($event) {
              // console.log($event.relatedTarget);
              that.blurText($event, that.canIdList);
            };
            item.onfocus = function ($event) {
              that.onFocus($event.target);
            };
            // item.onclick = function ($event) {
            //   // that.onContextClick($event)
            //   that.onClick($event);
            //   that.inputTxt = "";
            // };
            item.style.color = this.editorNo;
          } else {
            item.style.color = this.editorOff;
            that.setInsertSty(item, "disabled")
          }
        } else if (item.getAttribute("type") === "source") {
          item.parentNode.style.marginTop = "20px";
          item.style.color = "rgb(158, 165, 173)";
          item.style.display = "inline-block";
          item.style.outline = "none";
          item.style.whiteSpace = "normal";
          item.style.overflowWrap = "break-word";
          item.style.width = "100%";
          if (
            item.getAttribute("uid") &&
            item.getAttribute("uid") !== that.queryData.userId + "" &&
            marker === 1 &&
            taskType === 1
          ) {
            item.setAttribute("editable", "false");
          } else if (item.getAttribute("reviserid") &&
            item.getAttribute("reviserid") !== that.queryData.userId + "" &&
            marker === 1 &&
            taskType === 2) {
            item.setAttribute("editable", "false");
          } else if (item.getAttribute("secondreviserid") &&
            item.getAttribute("secondreviserid") !== that.queryData.userId + "" &&
            marker === 1 &&
            taskType === 3) {
            item.setAttribute("editable", "false");
          }

          if (item.getAttribute("uk") !== "1" && item.getAttribute("rf") > 0 && that.ifRepeatLock) {
            // 锁定重复句段
            item.setAttribute("editable", "false");
          } else if (item.getAttribute("uk") !== "1" && item.getAttribute("rp") > 0 && that.ifRepeatLock) {
            item.setAttribute("editable", "false");
          }
          if (item.getAttribute("editable") === "true") {
            item.setAttribute("contenteditable", that.contentEditableValue);
          }
          if (item.innerText === '') {
            item.setAttribute("contenteditable", "false");
          }
          item.oninput = function ($event) {
            if ($event.target.innerText !== that.myInnerText) {
              $event.target.innerText = that.myInnerText;
            }
          };
          item.onfocus = function ($event) {
            that.myInnerText = $event.target.innerText;
          };
          item.onclick = function ($event) {
            that.getCursortPosition($event);
          };
        }

      });
    },

    // 添加术语
    // async addTermSent(data) {
    //   // isReplace ? this.dialogVisible = true : null;
    //   // let params = {
    //   //   fileId: this.queryData.fileId,
    //   //   sourceSent: this.inputTxt,
    //   //   targetSent: this.targetInput,
    //   //   isReplace,
    //   // };
    //   // const res = await addTermSent(params);
    //   // this.dialogVisible = false
    //   // if (!res.success) {
    //   //   return
    //   // }
    //   // let data = res.result;
    //   this.$nextTick(() => {
    //     if (data.length > 0) {
    //       data.forEach(item => {
    //         let itemDom2 = this.$refs.viewBox2.querySelector(
    //           `span[sid='${item.id}']`);
    //         let itemDom = this.$refs.viewBox.querySelector(
    //           `span[sid='${item.id}']`);
    //         itemDom.innerHTML = item.sourceSent;
    //         itemDom2.innerHTML = item.targetSent;
    //         this.setSty(itemDom, itemDom2);
    //         // if (itemDom) {
    //         //   itemDom.innerHTML = item.sourceSent
    //         //   this.setTermSty(itemDom)  // 设置术语样式
    //         //   // itemDom.setAttribute("cid", this.setCanvasSort(itemDom));
    //         // }
    //         // if (itemDom2) {
    //         //   itemDom2.innerHTML = item.targetSent
    //         //   // itemDom2.setAttribute("cid", this.setCanvasSort(itemDom2));
    //         //   this.setTermSty(itemDom2)  // 设置术语样式
    //         //   this.setInsertSty(itemDom2) // 设置新增文本样式
    //         // }
    //       })
    //     }
    //   })
    // },
    css1(t, s) {
      s = document.createElement("style");
      s.innerText = t;
      document.body.appendChild(s);
    },
    //  单词补全
    AutoComple(e) {
      if (this.queryData.targetLang != "en") {
        return;
      }
      if (e.data === null || e.data === " ") {
        return;
      }
      let sentId = Number(e.target.getAttribute("sid"));
      this.mendSentId = sentId;
      let domList = this.$refs.viewBox2.querySelectorAll(`span[sid='${sentId}']`);
      this.AutoCompleMixin(domList[1], domList[0].innerText, 'span')
    },
    // 回车确认
    enterKey(e) {
      e = e || window.event;
      var k = e.keyCode || e.which;
      let taskType = this.queryData.taskType;
      let sentId = Number(e.target.getAttribute("sid"));
      let domList = this.$refs.viewBox2.querySelectorAll(`span[sid='${sentId}']`);
      if (k === 13) {
        e.returnValue = false;
        let isCommitVersion = 1
        this.updateFileSent(e.target, undefined, isCommitVersion);
        // this.changeTextOut(e.target)
        this.$nextTick(() => {
          domList[0].bor = 0;
          domList[1].bor = 0;
          domList[0].style.backgroundColor = "";
          // if (taskType == 1) {
          domList[1].style.backgroundColor = this.editorDe;
          // } else {
          //   e.target.style.backgroundColor = "#05D1F1";
          // }
        });
        var oAt = this.$refs.viewBox2;
        let dom = oAt.querySelectorAll(`span[type='target']`);
        dom.forEach((item, index) => {
          if (item.getAttribute("sid") == sentId && dom[index + 1]) {
            this.goFocus(dom, index + 1).focus()
          }
        })
      } else {
        // 实时对照
        if (this.contrastStatus) {
          this.contrastTag.innerHTML = this.contrastTag.innerText
        }
        if (domList[1].isContentEditable) {
          let range = window.getSelection().getRangeAt(0);
          if (this.startOffset != range.startOffset) {
            this.contrastDebounce(domList[0], domList[1])
          }
        }
      }
    },
    onClick(e) {
      this.isPostil = false;
      this.isSeekBox = false
      this.getHint(e);
    },
    setStyleFun() {

    },
    // 获取修改前批注集合
    getComments(rigTag) {

      let childNodes = Array.from(rigTag.childNodes);
      this.comList = [];
      childNodes.forEach((item, index) => {
        if (item.nodeType === 1 && item.getAttribute("cid") && item.getElementsByTagName("canvas").length) {
          let canList = item.getElementsByTagName("canvas");
          canList = Array.from(canList);
          canList.forEach(i => {
            let myLen = this.recursionChilds(item, 0);
            this.comList.push({
              id: i.getAttribute("canid"),
              len: myLen,
              text: this.getTxt(childNodes, i.getAttribute("canid"))
            })
          })
        }
      })
    },
    getprogress() {
      let urlInfo = this.$store.getters['editor/getUrlInfo'];
      if (urlInfo.type === "task" || urlInfo.type === "school") {
        let data = Object();
        Reflect.set(data, 'id', (urlInfo.fileId));
        Reflect.set(data, 'fileId', (urlInfo.fileId));
        Reflect.set(data, 'taskId', (urlInfo.taskId));
        Reflect.set(data, 'taskType', (urlInfo.taskType));
        this.$store.dispatch('editor/getTaskProgress', data);
      } else {
        this.$store.dispatch("editor/getFileInfo", { id: urlInfo.fileId })
      }
    },
    // 聚焦事件
    async onFocus(rigTag) {
      this.writingSpeed(); // 写作时间
      this.interpreteruid = rigTag.getAttribute("uid");
      // this.spanNodeInnerHTMl = e.srcElement.innerHTML //获取焦点时报错文本内容
      const top = this.$refs.viewBox2.scrollTop;
      let acticeClass = rigTag.getAttribute("sid");
      let domList = this.$refs.viewBox2.querySelectorAll(
        `span[sid='${acticeClass}']`
      );
      this.lefTagText = domList[0].innerText;
      // await this.queryBySentId([acticeClass]);
      let pid = rigTag.getAttribute("pid");
      pid ? this.isAddPostil = false : this.isAddPostil = true;
      // this.getmemory(domList[0].innerText)
      // this.getTerm(domList[0].innerText)
      let pos = rigTag.getBoundingClientRect();
      let postilDom = document.getElementById("postilBox");
      this.postilTarget = {
        txt: rigTag.innerText,
        sid: acticeClass,
        tag: rigTag
      };
      postilDom.style.top = pos.y + top - 100 + "px";
      setTimeout(() => {
        this.rigTagIntext = rigTag.innerText;
        this.rigTagInnerHTML = rigTag.innerHTML;
        let that = this;
        // let rigTag = e.target;
        let acticeClass = rigTag.getAttribute("sid");
        if (!acticeClass) {
          return;
        }
        this.mySid = acticeClass;
        let canTagList = rigTag.getElementsByTagName("canvas");
        canTagList = Array.from(canTagList);
        this.canIdList = [];
        canTagList.forEach(item => {
          this.canIdList.push(item.getAttribute("canid"))
        });
        // this.getComments(rigTag)

        let box;
        this.$nextTick(() => {
          box = this.$refs.viewBox;
          domList[0].bor = 1;
          rigTag.bor = 1;
          // rigTag.classList.add('styActive');
          let cssAry = [
            { s: "border", c: "1px solid rgba(234,177,39,1)" },
            { s: "boxShadow", c: "0px 6px 16px 0px rgba(215,222,191,0.5)" },
            { s: "borderRadius", c: "6px" },
            { s: "background", c: this.focusBack }
          ]
          this.setSpanStyle([rigTag], cssAry); // 设置样式
          domList[0].style.background = this.focusBack
        });
      }, 100);

    },
    // 失焦
    async blurText(e) {
      let event = e.target
      let relatedTarget = e.relatedTarget
      if (relatedTarget && ['revokeBtn', 'recoveryBtn'].includes(relatedTarget.id)) {
        setCursorEnd(event)
        return false
      }
      console.log('失去焦点');
      // 获取所有span
      this.interpreteruid = "";
      let sentId = Number(event.getAttribute("sid"));
      let status = Number(event.getAttribute("status"));
      let taskType = this.queryData.taskType;
      this.isWordBox = false;
      let domList = this.$refs.viewBox2.querySelectorAll(`span[sid='${sentId}']`);
      if (this.contrastStatus) {
        domList[0].innerText = this.lefTagText; // 实时对照
        this.contrastStatus = false;
      }
      if (document.getElementById("sourceEditer")) {
        let parentNode = domList[1].parentNode;
        let activeDom = document.getElementsByClassName("editer-box");
        activeDom = Array.from(activeDom)[0];
        parentNode.removeChild(activeDom)
      }
      domList[0].bor = 0;
      domList[1].bor = 0;
      let cssAry = [
        // { s: "border", c: "0px" },
        { s: "boxShadow", c: "" },
        { s: "borderRadius", c: "0px" },
        { s: "background", c: "" }
      ];
      domList[1].style.border = "0px";
      this.setSpanStyle([domList[0], domList[1]], cssAry)  // 设置样式

      let title = domList[1].getAttribute("title");
      let contenteditable =
        domList[1].getAttribute("contenteditable") === this.contentEditableValue;

      if (domList[0].bor === 1) {
        // 用来区分是否处于编辑
        domList[0].style.background = this.focusBack;
        domList[1].style.background = this.focusBack;
      } else if (
        (
          (status == 2 && taskType === 1) ||
          (status == 4 && taskType === 2) ||
          (status == 5 && taskType === 3)
        ) &&
        title !== "其他译员任务" &&
        contenteditable
      ) {
        domList[0].style.background = "";
        domList[1].style.background = this.editorDe;
      } else {
        domList[0].style.background = "";
        domList[1].style.background = "";
      }
      await this.disposeUpdate(event, this.canIdList, undefined)
      // this.writingSpeed(true)
    },
    // 修改防抖
    async changeTextOut(event) {
      let that = this;
      if (event === this.ev) {
        clearInterval(this.updateTime);
      }
      this.ev = event;
      this.updateTime = await window.setTimeout(async () => {
        if (that.rigTagIntext === event.innerText) {
          return
        }
        await that.changeText(event, [], true);
        let seekDebounce = debounce(that.seekChange, 500);
        seekDebounce();
      }, 50)
    },
    editerFocus(tag) {
      this.editerNode = tag;
      this.rigTagIntext = tag.rigTagIntext
    },
    // 修改
    async changeText(event = rightClickElement, canIdList = this.canIdList, updateHtml, timeOut = 550) {
      // 获取所有span
      let that = this;
      if (self.isEditer) {
        self.clearRightMenu()
      }
      if (event === this.ev) {
        clearInterval(this.updateTime);
      }
      if (event.innerText == "" || event.innerHTML === "<br>") {
        event.innerHTML = "&ensp;";
      } else if (event.innerText === "/n") {
        event.innerHTML = "&ensp;"
      }
      this.ev = event;
      let sentId = Number(event.getAttribute("sid"));
      this.isWordBox = false;
      // let 
      this.updateFileSent(event, updateHtml, timeOut)
    },



    async updateFileSent(event, updateHtml, isCommitVersion = 0, timeOut = 0) {
      if (this.isEditer) {
        this.clearRightMenu()
      }
      let sentId = Number(event.getAttribute("sid"));
      let status = Number(event.getAttribute("status"));
      let rigTag = this.$refs.viewBox2.querySelectorAll(`span[sid='${sentId}']`)[1];
      this.saveHint = "正在自动保存...";
      this.state = false;
      let taskType = this.queryData.taskType;
      let reg = /^c([0-9]+)$/;
      let timer;
      let costTime = this.oldTime ? (new Date() - this.oldTime - timeOut) / 1000 : undefined;
      if (costTime <= 1) {
        costTime = 1;
      } else {
        Math.round(costTime)
      }
      let params = {
        isSaveVersion: 1,
        isCommitVersion,
        isNewVersion: 1,
        sentId: sentId,
        fileId: this.queryData.fileId,
        content: event.innerText,
        companyCode: localStorage.myCompanyCode,
        taskType: taskType,
        status,
        taskId: this.queryData.taskId,
        costTime,
      };
      this.catReq1Service("/api/v1/file/updateFileSent", params).then((res) => {
        if (!res.success) {
          this.saveHint = "自动保存失败！";
          setTimeout(() => {
            this.saveHint = "";
          }, 500);
          return false;
        } else {
          this.saveHint = "自动保存成功！";
          this.writingSpeed();
          setTimeout(() => {
            this.saveHint = "";
          }, 500);
          if (parseInt(taskType) === 1) {
            rigTag.setAttribute("status", "2"); // 成功把状态改为2_翻译
          } else if (taskType === 2) {
            rigTag.setAttribute("status", "4"); // 成功把状态改为4_审校
          } else {
            rigTag.setAttribute("status", "5"); // 成功把状态改为4_复审
          }
          rigTag.style.backgroundColor = this.editorDe;
          var translation = document.getElementById("translation");
          var divNode = translation.getElementsByTagName("span");
          this.$nextTick(() => {
            for (let i of divNode) {
              //遍历所有div
              if (
                i.getAttribute("title") === ("文件内重复句段锁定" || "项目内跨文件重复句段锁定") &&
                i.getAttribute("sourceMd516") ===
                rigTag.getAttribute("sourceMd516")
              ) {
                i.innerHTML = event.innerText; // 修改相同句段的内容
              }
            }
          });

          !updateHtml ? this.getSentHtmlContent(sentId) // 获取修改后样式
            : this.updateHtmlIdList.push(sentId); // 替换后样式不立即更新
          clearTimeout(this.progressTime);
          this.progressTime = window.setTimeout(() => {
            this.getprogress();
          }, 10000);
        }
      }).catch(() => {
        this.saveHint = "自动保存失败！";
        setTimeout(() => {
          this.saveHint = "";
        }, 500);
        return false;
      }).finally(() => {
        this.state = true
      });
    },
    // 鼠标滑出
    styleOut(e) {
      this.$nextTick(() => {
        let tar = this.getNode(e.target);
        let acticeClass = tar.getAttribute("sid");
        if (!acticeClass) {
          return;
        }
        let domList = this.$refs.viewBox2.querySelectorAll(
          `span[sid='${acticeClass}']`
        );
        let taskType = this.queryData.taskType;
        let status = domList[0].getAttribute("status") || domList[1].getAttribute("status");
        let title = domList[0].getAttribute("title") || domList[1].getAttribute("title");
        let contenteditable = domList[0].getAttribute("contenteditable") === this.contentEditableValue || domList[1].getAttribute("contenteditable") === "0";
        if (domList[0].bor === 1) {
          // 用来区分是否处于编辑
          domList[0].style.background = this.focusBack;
          domList[1].style.background = this.focusBack;
        } else if (
          (
            (status == 2 && taskType === 1) ||
            (status == 4 && taskType === 2) ||
            (status == 5 && taskType === 3)
          ) &&
          title !== "其他译员任务" &&
          contenteditable
        ) {
          if (domList[0]) {
            domList[0].style.background = "";
          }
          if (domList[1]) {
            domList[1].style.background = this.editorDe;
          }
        } else {
          if (domList[0]) {
            domList[0].style.background = "";
          }
          if (domList[1]) {
            domList[1].style.background = "";
          }
        }
      });
    },
    // 鼠标划入
    styleOver(e) {
      this.$nextTick(() => {
        document.execCommand("unlink");
        let tar = this.getNode(e.target);
        let acticeClass = tar.getAttribute("sid");
        if (!acticeClass) {
          return;
        }
        let domList = this.$refs.viewBox2.querySelectorAll(
          `span[sid='${acticeClass}']`
        );
        // console.log(domList[0], "-------")
        domList[0] ? domList[0].style.background = this.bCb ? "#838eb4" : "#ECF2D8" : domList[0];
        domList[1] ? domList[1].style.background = this.bCb ? "#838eb4" : "#ECF2D8" : domList[1]; //this.focusBack;
      });
    }
  }
};
</script>
<style lang="less">
.styActive {
  border: 1px solid rgb(234, 177, 39);
  box-shadow: rgba(152, 136, 120, 0.4) 0px 0px 5px 0px;
  border-radius: 3px;
  background: #f6f6f2;
  word-wrap: break-word;
  // width: 100%;
}

#redactBox {
  .seekActive {
    background: yellow;
  }

  .current-box {
    background: rgb(163, 217, 241);
  }
}

.backColorB {
  background: rgba(33, 44, 50, 1) !important;

  .main-box {
    .styActive {
      background: #535d78;
    }
  }
}

#translation {
  .postilBut {
    background: url("~@/assets/imgs/editor/ckbz_normal.png") no-repeat;
    height: 18px;
    width: 18px;
    display: inline-block;
    position: absolute;
    right: -28px;
    top: 0px;
    cursor: pointer;
  }

  .postilBut:active {
    background: url("~@/assets/imgs/editor/ckbz_press.png") no-repeat;
  }
}

.backColorB {
  #translation {
    .postilBut {
      background: url("~@/assets/imgs/editor/yj_ckbz_normal.png") no-repeat;
    }
  }
}
</style>
<style lang="less" scoped>
.backColorB {
  background: rgba(33, 44, 50, 1) !important;

  .main-box {
    .styActive {
      background: #535d78;
    }
  }

  #sourceText {
    background: rgba(48, 51, 60, 1) !important;

    span {
      color: #c5c5c5 !important;
    }

    div {
      p {
        .term {
          color: #2f333b !important;
        }
      }
    }
  }

  #translation {
    background: rgba(48, 51, 60, 1) !important;
    color: #c6c6c6 !important;
  }

  .progressBox {
    color: white !important;
  }

  /deep/ .el-progress-bar__outer {
    background-color: #4d515f !important;
  }

  /deep/ .el-progress-bar__inner {
    background: #507383 !important;
  }

  /*下拉框颜色*/
  /deep/ .el-popper {
    /deep/ .el-scrollbar {
      /deep/ .el-scrollbar__view {
        /deep/ .el-select-dropdown__item {
          background: #507383 !important;
        }

        background: #507383 !important;
      }
    }
  }

  .operationBox {
    background: rgba(48, 51, 60, 1) !important;
    color: #c6c6c6 !important;

    h3 {
      background: #507383 !important;
    }

    h4 {
      color: #c6c6c6;
    }

    h5 {
      color: #c6c6c6;
    }

    .find {
      div {
        input {
          background: #507383 !important;
          border: none !important;
          color: white !important;
        }

        input::-webkit-input-placeholder {
          color: white !important;
        }
      }

      .findBox {
        border: 1px solid #507383 !important;

        li {
          color: white !important;
        }
      }
    }

    .addTerm {
      input {
        background: #507383 !important;
        border: none !important;
        color: white !important;
      }

      input::-webkit-input-placeholder {
        color: white !important;
      }
    }

    button {
      background: #507383 !important;
      color: white !important;
      border: none !important;
    }

    button:hover {
      background: #405964 !important;
    }

    button:active {
      background: #2c4753 !important;
    }
  }

  /deep/ .el-select {
    /deep/ .el-input__inner {
      background: #507383 !important;
      border: none !important;
      color: white !important;
    }
  }

  /deep/ .el-button {
    background: #507383 !important;
    border: none !important;
    color: white !important;
  }
}

.editor-container {
  height: 100%;
  background: #f1f5ff;
  position: relative;
  .editor-header-top {
    height: 60px;
    // background: rgba(255, 255, 255, 1);
  }
}

.main-box {
  width: 100%;
  float: left;
  height: calc(100% - 130px);
  position: relative;
  z-index: 5;
  word-wrap: break-word;
  word-break: normal;
  // pointer-events: none;
  span {
    white-space: normal !important;
  }

  .seekActive {
    background: yellow;
  }

  .current-box {
    background: rgb(163, 217, 241);
  }

  .styActive {
    display: block;
    border: 1px solid rgb(234, 177, 39);
    box-shadow: rgba(152, 136, 120, 0.4) 0px 0px 5px 0px;
    // padding: 6px;
    // margin: 2px 0px;
    border-radius: 3px;
    background: #f6f6f2;
    word-wrap: break-word;
    // width: 100%;
    span {
      // display: inline-block;
    }
  }

  /deep/ .content-box {
    // overflow-y: auto;
    height: 100%;
    // width: calc(100% - 500px);
    width: 70%;
    float: left;
    margin: 0 auto;
    pointer-events: auto;
    box-sizing: border-box;
    padding-left: 20px;
    position: relative;

    span {
      position: relative;
    }

    a {
      display: inline-block;
    }

    span[contenteditable]:hover::after {
      content: url("~@/assets/imgs/editor/bianji.png");
      position: absolute;
      margin-left: 10px;
    }

    #translation {
      background: #fff;
      width: 80%;
      max-width: 1000px;
      float: right;
      padding: 40px;
      height: 100%;
      overflow-y: auto;
      box-sizing: border-box;
    }

    .riBoxSw {
      position: absolute;
      top: 50%;
      height: 50px;
      width: 13px;
      right: -13px;
      z-index: 30;
      font-size: 24px;
      transform: translateY(-50%);
      cursor: pointer;
    }

    .icon-left {
      background: url("~@/assets/imgs/editor/zhankai_normal.png") no-repeat;
    }

    .icon-left:active {
      background: url("~@/assets/imgs/editor/zhankai_press.png") no-repeat;
    }

    .icon-right {
      background: url("~@/assets/imgs/editor/shouqi_normal.png") no-repeat;
    }

    .icon-right:active {
      background: url("~@/assets/imgs/editor/shouqi_press.png") no-repeat;
    }
  }

  .rigContantBox {
    float: left;
    margin-left: 30px;
    width: 300px;
    height: 100%;
    margin-right: 20px;
    position: relative;
  }
}

.dialog-main {
  // min-height: 120px;
  textarea {
    resize: none;
    width: 100%;
    height: 100px;
  }
}

.editer-box {
  position: fixed;
  overflow: auto;
  z-index: 1900;
  background: white;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 0px 6px 0px rgba(74, 74, 74, 0.3);
  min-width: 200px;

  .source-editer-box {
    border: 1px solid rgb(238, 28, 185);
    padding: 5px;
  }

  .translation-editer-box {
    margin-top: 5px;
    padding: 5px;
    border: 1px solid rgb(238, 28, 185);
  }

  .el-button {
    margin-top: 10px;
    float: right;
  }

  .popper__arrow {
    left: 50%;
    filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
    position: absolute;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border: 5px solid;
  }

  .popper-top {
    top: -10px;
    border-color: transparent transparent white;
  }

  .popper-bottom {
    bottom: -10px;
    border-color: white transparent transparent;
  }
}

.postil-box {
  background: white;
  min-height: 80px;
  /* height: 120px; */
  width: 200px;
  position: fixed;
  top: 393px;
  left: 495px;
  transform-origin: center top;
  z-index: 2001;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  word-break: break-all;
  padding: 15px;

  h5 {
    margin-bottom: 10px;

    .postil-sort {
      min-width: 20px;
      min-height: 20px;
      border: 1px solid rgb(215, 149, 43);
      color: rgb(215, 149, 43);
      border-radius: 50px;
      display: inline-block;
      text-align: center;
      margin-right: 10px;
      font-size: 12px;
    }
  }

  .postil_arrow {
    top: -10px;
    left: 50%;
    filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
    position: absolute;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border: 5px solid;
    border-color: transparent transparent white;
  }

  .postil-top {
    top: -10px;
    border-color: transparent transparent white;
  }

  .postil-bottom {
    top: 100%;
    border-color: white transparent transparent;
  }
}
</style>
